import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CheckoutDeliveryAddressFacade } from '@spartacus/checkout/base/root';
import { Address, StateWithProcess, StateWithUser, UserAddressService, UserIdService } from '@spartacus/core';
import { AddressBookComponentService } from '@spartacus/user/profile/components';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomAddressBookComponentService extends AddressBookComponentService {
  userId: string;

  constructor(
    protected userAddressService: UserAddressService,
    protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    protected store: Store<StateWithUser | StateWithProcess<void>>,
    protected userIdService: UserIdService
  ) {
    super(userAddressService);
  }

  getAddresses(): Observable<Address[]> {
    return this.userAddressService.getAddresses();
  }

  getAddressesStateLoading(): Observable<boolean> {
    return this.userAddressService.getAddressesLoading();
  }

  loadAddresses(): void {
    this.userAddressService.loadAddresses();
  }

  addUserAddress(address: Address): void {
    this.userAddressService.addUserAddress(address);
  }

  updateUserAddress(addressId: string, address: Address): void {
    this.userAddressService.updateUserAddress(addressId, address);
    this.checkoutDeliveryAddressFacade.clearCheckoutDeliveryAddress();
  }

}
